// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__6eahu","icon":"CloseButton_icon__0J6Fl"};